'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("cbcService", function () {
  var structuresGissler = [{
    id: "A",
    label: "A"
  }, {
    id: "B",
    label: "B"
  }, {
    id: "C",
    label: "C"
  }, {
    id: "D",
    label: "D"
  }, {
    id: "E",
    label: "E"
  }, {
    id: "HORS_CHARTE",
    label: "H.C"
  }];
  var indicesGissler = [{
    id: "UN",
    label: "1"
  }, {
    id: "DEUX",
    label: "2"
  }, {
    id: "TROIS",
    label: "3"
  }, {
    id: "QUATRE",
    label: "4"
  }, {
    id: "CINQ",
    label: "5"
  }, {
    id: "HORS_CHARTE",
    label: "H.C"
  }];
  var cbcService = {
    getStructuresGisslers: function getStructuresGisslers() {
      return structuresGissler;
    },
    getIndicesGissler: function getIndicesGissler() {
      return indicesGissler;
    },
    getCbcLabel: function getCbcLabel(cbc, long) {
      if (!cbc || !cbc.structure || !cbc.indice) {
        return long ? "Non classifié" : "N.C";
      }
      if (cbc.structure == "HORS_CHARTE" || cbc.indice === "HORS_CHARTE") {
        return long ? "Hors charte" : "H.C";
      } else {
        return cbcService.getStructureLabel(cbc.structure) + cbcService.getIndiceLabel(cbc.indice);
      }
    },
    getStructureLabel: function getStructureLabel(structureId) {
      return _.find(structuresGissler, {
        id: structureId
      }).label;
    },
    getIndiceLabel: function getIndiceLabel(structureId) {
      return _.find(indicesGissler, {
        id: structureId
      }).label;
    }
  };
  return cbcService;
});
ngModule.filter("cbc", function (cbcService) {
  return function cbcFilter(cbc, long) {
    return cbcService.getCbcLabel(cbc, long);
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/services/cbcService.js
// module id = 2867
// module chunks = 13